import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const PolitiqueCookies = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-5xl font-serif font-bold text-[#1a1a1a] mb-12 text-center">
            Politique cookies
          </h1>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Qu'est-ce qu'un cookie ?</h2>
              <p className="text-gray-700">
                Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, smartphone, tablette) lors de la visite d'un site internet. Il permet au site de mémoriser des informations sur votre visite.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Cookies utilisés sur Giletau</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold text-[#1a1a1a] mb-3">Cookies techniques (nécessaires)</h3>
                  <p className="text-gray-700 mb-3">
                    Ces cookies sont indispensables au bon fonctionnement du site. Ils ne nécessitent pas votre consentement.
                  </p>
                  <ul className="space-y-2">
                    <li className="text-gray-700">Cookies de session</li>
                    <li className="text-gray-700">Cookies de sécurité</li>
                    <li className="text-gray-700">Cookies de préférences de navigation</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-[#1a1a1a] mb-3">Cookies analytiques</h3>
                  <p className="text-gray-700">
                    Nous utilisons des cookies pour analyser l'utilisation du site et améliorer votre expérience. Ces données sont anonymisées et ne permettent pas de vous identifier personnellement.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Ce que nous NE faisons PAS</h2>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-close-circle-fill text-red-600 text-xl mt-1 flex-shrink-0"></i>
                  <span className="text-gray-700">Nous n'utilisons pas de cookies publicitaires</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-close-circle-fill text-red-600 text-xl mt-1 flex-shrink-0"></i>
                  <span className="text-gray-700">Nous ne partageons pas vos données avec des régies publicitaires</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-close-circle-fill text-red-600 text-xl mt-1 flex-shrink-0"></i>
                  <span className="text-gray-700">Nous n'utilisons pas de cookies de tracking invasif</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Gérer vos cookies</h2>
              <p className="text-gray-700 mb-4">
                Vous pouvez à tout moment configurer votre navigateur pour refuser les cookies ou être averti avant d'accepter un cookie.
              </p>
              <p className="text-gray-700">
                <strong>Comment gérer les cookies selon votre navigateur :</strong>
              </p>
              <ul className="space-y-2 mt-3">
                <li className="text-gray-700"><strong>Chrome :</strong> Paramètres &gt; Confidentialité et sécurité &gt; Cookies</li>
                <li className="text-gray-700"><strong>Firefox :</strong> Options &gt; Vie privée et sécurité &gt; Cookies</li>
                <li className="text-gray-700"><strong>Safari :</strong> Préférences &gt; Confidentialité &gt; Cookies</li>
                <li className="text-gray-700"><strong>Edge :</strong> Paramètres &gt; Confidentialité &gt; Cookies</li>
              </ul>
              <p className="text-gray-700 mt-4 text-sm italic">
                Attention : Le refus de tous les cookies peut affecter le bon fonctionnement de certaines fonctionnalités du site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Durée de conservation</h2>
              <p className="text-gray-700">
                Les cookies techniques sont conservés pour la durée de votre session de navigation. Les cookies analytiques sont conservés pour une durée maximale de 13 mois.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Contact</h2>
              <p className="text-gray-700">
                Pour toute question concernant notre politique cookies, contactez-nous à : <a href="mailto:contact@giletau.fr" className="text-blue-600 hover:underline cursor-pointer">contact@giletau.fr</a>
              </p>
            </section>

            <section>
              <p className="text-sm text-gray-500 italic">
                Dernière mise à jour : Janvier 2025
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PolitiqueCookies;
